import { render, staticRenderFns } from "./levelUp.vue?vue&type=template&id=51c561f4&scoped=true"
import script from "./levelUp.vue?vue&type=script&lang=js"
export * from "./levelUp.vue?vue&type=script&lang=js"
import style0 from "./levelUp.vue?vue&type=style&index=0&id=51c561f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c561f4",
  null
  
)

export default component.exports